import { StatusVariant } from '@factorialco/f0-react'

export default function statusVariant(status?: string): StatusVariant {
  if (!status) return 'neutral'

  switch (status) {
    case 'approved':
      return 'info'
    case 'draft':
      return 'neutral'
    case 'in_payroll':
      return 'info'
    case 'paid':
      return 'info'
    case 'rejected':
      return 'critical'
    case 'pending':
      return 'warning'
    case 'sent_to_pay':
      return 'info'
    case 'changes_requested':
      return 'warning'
    default:
      return 'neutral'
  }
}
